import { List, Map } from 'immutable';
import { createSelector } from 'reselect';

export const getStep = (state) => state.get('step', 1);

export const getProductsDetails = (state) => state.get('productsDetails', Map());

export const getConvention = createSelector(
  getProductsDetails,
  productsDetails =>  productsDetails.get('convention', Map())
);

export const getProducts = createSelector(
  getProductsDetails,
  productsDetails =>  productsDetails.get('products', List())
);
